export default function exportFile({ source, name }) {
    const hiddenElement = document.createElement('a');
    hiddenElement.href = source;
    hiddenElement.target = '_blank';
    hiddenElement.download = name;
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
}
